module.exports = __webpack_public_path__ + "assets/media/hit.cbc1ecb3.mp3";